module.exports = __webpack_public_path__ + "static/media/Banner-Option3.03914257.png";